import {IServiceFactoryExtended} from "../app-react/services/service-factory-extended.interface";

export interface IOrbitBroadcastChannelSubscription {
    unsubscribe(): void;
}

export class OrbitBroadcastChannel<TMessage> {
    constructor(private readonly channelName: string, private readonly services: IServiceFactoryExtended) {
        this._broadcastChannel = new BroadcastChannel(channelName);
        this._broadcastChannel.addEventListener('message', this._channelMessageHandler);
        this._broadcastChannel.addEventListener('messageerror', this._channelMessageErrorHandler);
    }

    private readonly _broadcastChannel: BroadcastChannel;

    private _subscribers: Array<(message: TMessage) => void> = [];

    sendMessage(message: TMessage): void {
        if(this._isClosed) {
            this.services.logger.warning(`Attempt to send message on a closed channel ${this.channelName}`);
            return;
        }
        try {
            this._broadcastChannel.postMessage(message);
        } catch (err) {
            this.services.logger.error(`Failed to broadcast message for channel ${this.channelName}`, err);
        }
    }
    private _isClosed = false;
    close(): void {
        this._subscribers = [];
        try {
            this._broadcastChannel.removeEventListener('message', this._channelMessageHandler);
            this._broadcastChannel.close();
        } catch (err) {
            this.services.logger.error(`Failed to close broadcast channel ${this.channelName}`, err);
        } finally {
            this._isClosed = true;
        }

    }


    private _channelMessageHandler = (event: MessageEvent<TMessage>) => {
        if(!event.data) {
            return;
        }

        for(let subscriber of this._subscribers) {
            try {
                subscriber(event.data);
            } catch (err) {
                this.services.logger.error(`${this.channelName} channel message subscriber failed`, err);
            }
        }
    }

    private _channelMessageErrorHandler = (event: MessageEvent<TMessage>) => {
        this.services.logger.error(`Sending message over ${this.channelName} channel failed`, event);
    }

    subscribe(subscriber: (message: TMessage) => void): IOrbitBroadcastChannelSubscription {
        this._subscribers.push(subscriber);
        return {
            unsubscribe: () => {
                const index = this._subscribers.findIndex(s => s === subscriber);
                if(index >= 0) {
                    this._subscribers.splice(index, 1);
                }
            }
        };
    }
}